import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import bindActionCreators from "redux/es/bindActionCreators";
import {CardElement, injectStripe, CardNumberElement, CardCvcElement, CardExpiryElement} from "react-stripe-elements";
import GridContainer from "../../../components/material-pro/Grid/GridContainer";
import GridItem from "../../../components/material-pro/Grid/GridItem";
import withStyles from "@material-ui/core/es/styles/withStyles";
import injectedCheckoutFormStyles from "../jss/InjectedCheckoutFormStyles";
import Grow from "@material-ui/core/es/Grow/Grow";
import FormHelperText from "@material-ui/core/es/FormHelperText/FormHelperText";
import Field from "redux-form/es/Field";
import ReduxInsideLabelTextField from "../../../components/reduxFields/ReduxInsideLabelTextField";

class InjectedCheckoutForm extends Component {

    render() {
        const {classes, handleCardErrors, error} = this.props;
        return (
            <div>
                    <GridContainer className={classes.frontCard}>
                        <GridItem md={12} sm={12} xs={12}>
                            <label className={classes.formLabel}>
                                Card number
                                <CardNumberElement
                                className={classes.formInput}
                                onChange={event => {
                                    console.log("CardNumberElement [change]", event);
                                    handleCardErrors(event)
                                }}
                                />
                            </label>
                        </GridItem>
                        <GridItem md={8} sm={7} xs={12}>
                            <label className={classes.formLabel}>
                                Name on card
                                <Field
                                    className={classes.formInputField}
                                    name="cardName"
                                    component={ReduxInsideLabelTextField}
                                />
                            </label>
                        </GridItem>
                        <GridItem md={4} sm={5} xs={12}>
                            <label className={classes.formLabel}>
                                Expiration date
                                <CardExpiryElement
                                className={classes.formInput}
                                onChange={event => {
                                    console.log("CardNumberElement [change]", event);
                                    handleCardErrors(event)
                                }}
                                />
                            </label>
                        </GridItem>

                        {error &&<GridItem sm={12} md={12}>
                            <Grow in={error}>
                                <FormHelperText error>{error}</FormHelperText>
                            </Grow>
                        </GridItem>}
                    </GridContainer>


                        
                    <GridContainer className={classes.backCard}>
                        <GridItem md={12} sm={12} xs={12} className={classes.backCardGridItem}>
                                <div className={classes.backCardStripe} />
                                <label className={classes.formLabelCvv}>
                                        CVV / CVC
                                        <CardCvcElement
                                        className={classes.formInput}
                                        onChange={event => {
                                            console.log("CardNumberElement [change]", event);
                                            handleCardErrors(event)
                                        }}
                                        />
                                </label>
                        </GridItem>
                    </GridContainer>
                    

                    
                
            </div>
                
        );
    }
}

const mapStateToProps = ({}) => ({});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(injectedCheckoutFormStyles)(InjectedCheckoutForm));


// WEBPACK FOOTER //
// ./src/containers/billing/components/InjectedCheckoutForm.js